'use client';

import { RadixSwitch } from '../../../../components/ui/switch';
import { cn } from '../../../../lib/utils';
import * as SwitchPrimitive from '@radix-ui/react-switch';

export type SwitchProps = React.ComponentProps<typeof SwitchPrimitive.Root>;

export default function Switch({ className, ...props }: SwitchProps) {
  return (
    <RadixSwitch
      className={cn(className)}
      {...props}
    />
  );
}
